@if ({
  selectedAttribute: selectedAttribute$ | async,
  addClicked: addClicked$ | async,
  }; as data) {
  <emm-management-layout>
    <emm-progress-bar [isLoading$]="anyLoading$"></emm-progress-bar>
    <emm-search-filter
      [addDialog]="true"
      [attr.data-testid]="'attribute_search_bar'"
      [fields]="fields$ | async"
      [isAdminOrAuthor]="(this.isAdmin || this.isAuthor) && !isMMSAuthor"
      [isSuperAdmin]="this.isSuperAdmin"
      [componentName]="'attributes'"
      [displaySearchWithOptions]="false"
      layout-center-header
      (add)="openCreateItemForm()"
      (filter)="onFilter($event)"
    ></emm-search-filter>
    <emm-generic-items-list
      [items]="attributesAsGenericItems$ | async"
      [isReadOnly]="isReadOnly$ | async"
      [contextMenuActions]="attributesContextMenuActions"
      (onSelectItem)="onSelectAttribute($event)"
      layout-center-content
    ></emm-generic-items-list>
    @if (data.selectedAttribute && !data.addClicked) {
      <emm-management-attributes-header
        layout-right-header
        [name]="data.selectedAttribute.name"
        [tag]="data.selectedAttribute.tag"
        [type]="data.selectedAttribute.type"
      ></emm-management-attributes-header>
    }
    @if (!data.addClicked) {
      <emm-management-attributes-form
        #form
        layout-right-content
        [isSuperAdmin]="isSuperAdmin"
        [isAdmin]="isAdmin"
        (showButtons)="renderButtons($event)"
        (disableButtons)="handleCancel($event)"
      ></emm-management-attributes-form>
    }
    @if (data.addClicked) {
      <emm-management-attributes-header
        layout-right-header
        [name]="'New Attribute'"
        [tag]="'TBD'"
        [type]="'TBD'">
      </emm-management-attributes-header>
    }
    @if (data.addClicked) {
      <emm-management-attributes-creation-form
        #form
        layout-right-content>
      </emm-management-attributes-creation-form>
    }
    @if (isSuperAdmin && (showButtons | async) && !isMMSAuthor) {
      <emm-management-attributes-footer
        [disableCancel]="disableButtons  | async"
        [disableUpdate]="disableButtons  | async"
        layout-right-footer
        (cancel)="cancel()" (submit)="submit()"
      ></emm-management-attributes-footer>
    }
  </emm-management-layout>
}
